import { useQuery } from '@tanstack/react-query';
import { useStore } from 'zustand';
import { useSession } from '@/features/auth';
import { companyOptionsQuery } from './company-options-query';
import { GROUP_SCOPE, resolveCompanyScope, type ResolvedCompanyScope } from './company-scope';
import { companyScopeStore } from './company-scope-store';

/** Escopo ativo e se ele já pode filtrar consultas. */
export interface ActiveCompanyScope extends ResolvedCompanyScope {
  /** `false` enquanto as empresas permitidas carregam (não dispare consultas filtradas). */
  isReady: boolean;
}

/**
 * Escopo ativo do cabeçalho, validado contra as empresas permitidas. Toda tela que lista dados
 * por empresa deve mandar `companyIds` à API e incluí-lo na query key do TanStack Query.
 */
export function useCompanyScope(): ActiveCompanyScope {
  const organizationId = useSession((state) => state.session?.organizationId ?? '');
  const stored = useStore(companyScopeStore, (state) => state.scope);
  const options = useQuery({
    ...companyOptionsQuery(organizationId),
    enabled: organizationId !== '' && stored.kind !== 'GROUP',
    meta: { silent: true },
  });
  if (stored.kind === 'GROUP') return { scope: GROUP_SCOPE, companyIds: null, isReady: true };
  if (options.isSuccess)
    return { ...resolveCompanyScope(stored, options.data.items), isReady: true };
  return { scope: GROUP_SCOPE, companyIds: null, isReady: options.isError };
}
